<palantir-accordion [title]="definition().label" [open]="true">
  @if (canShowFilter()) {
    <div class="text-input__container">
      @if (definition().description?.length) {
        <palantir-text class="text-input__description" size="base" type="description">{{
          definition().description
        }}</palantir-text>
      }
      <palantir-input>
        <input
          [type]="inputType()"
          [placeholder]="definition().placeholder ?? ''"
          [formControl]="control()"
        />
        <palantir-filter-modal-error-display
          palantir-input-error
          [control]="control()"
          [validatorsMessages]="definition().validatorsMessages"
        />
      </palantir-input>
    </div>
  } @else {
    <div class="filter-dialog__banner">
      <palantir-icon name="info-outline" class="filter-dialog__banner__icon" />
      <palantir-text size="base" type="description">{{
        definition().dependsOn?.placeholder
      }}</palantir-text>
    </div>
  }
</palantir-accordion>
